module.exports = __webpack_public_path__ + "static/media/whole-article-image2.8032ba04.jpg";